import { render, staticRenderFns } from "./PostingDetailsWidget.vue?vue&type=template&id=45ca441e&scoped=true&"
import script from "./PostingDetailsWidget.vue?vue&type=script&lang=js&"
export * from "./PostingDetailsWidget.vue?vue&type=script&lang=js&"
import style0 from "./PostingDetailsWidget.vue?vue&type=style&index=0&id=45ca441e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca441e",
  null
  
)

export default component.exports